import './dayjs.extend';
import { ApolloProvider } from '@apollo/client';
import { PToast } from '@porsche-design-system/components-react';
import AppRoutes from './AppRoutes';
import apolloClient from './apolloClient';
import UserSessionProvider from './contexts/UserSession';
import SubscriptionManager from './subscriptions';

const App = () => (
    <ApolloProvider client={apolloClient}>
        <UserSessionProvider>
            <SubscriptionManager />
            <AppRoutes />
            <PToast data-cy="notification" inert={undefined} />
        </UserSessionProvider>
    </ApolloProvider>
);

export default App;
